export default {
    DSL: 'Diesel',
    GSL: 'Gasoline',
    HYB: 'Hybrid',
    ELE: 'Electric',
    HYD: 'Hydrogen',
    PIH: 'Plug-in Hybrid',
};
